import React from 'react';
import { Link } from 'react-router-dom';

// Helper function to resolve image URLs
const getImageUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('/media/')) {
    return `https://ramsisindustry.com${url}`;
  }
  return url;
};

const MegaMenuCard = ({ category, isArabic }) => {
  return (
    <Link 
      to={`/category/${category.id}/${category.name.replace(/\s+/g, '-').toLowerCase()}`} 
      className="group relative w-full h-full max-w-2xl mx-auto rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500 block"
    >
      {/* Background Image Container */}
      <div 
        className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110"
        style={{ backgroundImage: `url(${getImageUrl(category.image) || 'https://via.placeholder.com/300x200'})` }}
      ></div>

      {/* Overlay: Changed from pure flat bg to a premium gradient */}
      <div className="absolute inset-0 bg-gradient-to-r from-primary/95 to-primary/60 group-hover:to-primary/40 transition-all duration-500"></div>

      {/* Content */}
      <div className="relative flex flex-col md:flex-row items-center justify-between p-5 h-full z-10 w-full">
        
        <div className={`w-full text-center ${isArabic ? 'md:text-right' : 'md:text-left'} flex flex-col justify-center h-full`}>
          <h3 className="text-xl font-bold text-white mb-1 transform transition-transform duration-300 group-hover:-translate-y-1">
            {isArabic ? category.name_ar : category.name}
          </h3>
          <p className="text-xs text-white/70 opacity-0 group-hover:opacity-100 transform translate-y-2 group-hover:translate-y-0 transition-all duration-300">
             {isArabic ? 'تصفح المجموعة' : 'Explore Collection'}
          </p>
        </div>
        
        {/* Sleeker Button on the opposite side */}
        <div className={`hidden md:flex mt-4 md:mt-0 ${isArabic ? 'mr-auto' : 'ml-auto'}`}>
          <div className="flex items-center justify-center w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm border border-white/30 text-white transform transition-transform duration-500 group-hover:bg-white group-hover:text-primary group-hover:rotate-[-45deg]">
            <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ${isArabic ? 'rotate-180 group-hover:rotate-0' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </div>
        </div>

      </div>
    </Link>
  );
};

export default MegaMenuCard;
